import PagamentoBoleto from "./PagamentoBoleto";

export default PagamentoBoleto;
